import React, { useEffect } from 'react'; // Import useEffect
import Lottie from 'react-lottie';
import animationData from './animation.json'; // Make sure this path is correct
import './ThankYouPage.css';
import { Helmet } from "react-helmet";
// Import the Cal.com embed component and API hook
import Cal, { getCalApi } from "@calcom/embed-react";

const ThankYouPage = () => {
  const defaultOptions = {
    loop: false, // Often thank you animations don't loop
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  // Cal.com Configuration Effect
  useEffect(() => {
    (async function () {
      try {
        // Initialize Cal.com API - namespace helps isolate config if multiple embeds exist
        const cal = await getCalApi({ namespace: "thankYouPageBooking" });
        // Configure the UI for embeds with this namespace
        cal("ui", {
          "styles": { "branding": { "brandColor": "#032f5e" } }, // Example: Brand color
          "hideEventTypeDetails": false,
          "layout": "month_view" // Or "week_view", "column_view"
        });
         console.log("Cal.com UI configured for namespace: thankYouPageBooking");
      } catch (error) {
        console.error("Failed to initialize or configure Cal.com API:", error);
      }
    })();
  }, []); // Empty dependency array ensures this runs only once on mount

  // --- Your Cal.com Link ---
  // IMPORTANT: Replace this with your actual Cal.com link slug
  const calLink = "gfa-admin-fczjtr/30min"; // e.g., "your-username/event-type"

  return (
    <div className="thank-you-container">
      <Helmet>
        {/* Facebook Pixel Script */}
        <script type="text/javascript">
          {`
            !function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '699539346078860');
fbq('track', 'PageView');
fbq('track', 'Lead');

          `}
        </script>
        {/* Facebook Pixel NoScript Fallback */}
        <noscript>
          {`
           <img height="1" width="1" style="display:none"
src="https://www.facebook.com/tr?id=699539346078860&ev=PageView&noscript=1"
/>
          `}
        </noscript>
        <title>Thank You & Schedule Call</title> {/* Updated page title */}
      </Helmet>

      {/* Success Message and Animation Section */}
      <div className="content-wrapper top-section">
        <h1 className="thank-you-heading">
        Your Payment is Received. Please book your call

        </h1>

        <div className="animation-container">
          <Lottie options={defaultOptions} height={180} width={180} /> {/* Slightly smaller default size */}
        </div>

        <p className="followup-text">
          
        </p>
      </div>

      {/* Cal.com Embed Section */}
      <div className="cal-embed-container">
         <h2 className="cal-embed-heading"></h2> {/* Add heading */}
        <Cal
          namespace="thankYouPageBooking" // Match the namespace used in useEffect
          calLink={calLink} // Use your actual calLink
          style={{ width: "100%", height: "100%", overflow: "scroll" }}
          // Config set via useEffect is generally preferred for UI settings
        />
      </div>
    </div>
  );
};

export default ThankYouPage;